import { useMsal } from "@azure/msal-react";
import { Menu, MenuButton, MenuItem, MenuList, MenuPopover, MenuTrigger } from "@fluentui/react-components";
import Status from "../../enums/Status";
import { useEffect, useState } from "react";
import userService from "../../services/userService";

export default function AccountQuickActions() {
    const { accounts, instance } = useMsal();
    const account = accounts[0];

    const [user, setUser] = useState<any>(null);
    const [status, setStatus] = useState<Status>(Status.LOADING);

    useEffect(() => {
        userService.getUser()
            .then(response => {
                setUser(response);
                setStatus(Status.LOAD_SUCCESS);
            })
            .catch(() => setStatus(Status.LOAD_ERROR));
    }, []);

    const handleUserClick = async () => {
        await userService.getUser();  
    };

    const handleLogoutClick = () => instance.logout();
    
    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <MenuButton>
                    {
                        (status !== Status.LOAD_SUCCESS && account.username) || user.name
                    }
                </MenuButton>
            </MenuTrigger>

            <MenuPopover>
                <MenuList>
                    <MenuItem onClick={handleUserClick}>User</MenuItem>
                    <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
}